import React, { useEffect } from "react";
import { Outlet, useLoaderData } from "react-router-dom";

import Location from "@r6digital/rapidstor-types/react/entities/Location";

import { injectSiteTheme } from "@/core/utils/theme";

export default function TestRoot() {
  const location = useLoaderData() as Location;

  useEffect(() => {
    if (location) {
      const rapidstorMainColor = window.rapidstor_settings?.app_config?.journey?.themeColor ?? location.skin.mainColour ?? null;
      injectSiteTheme(location, rapidstorMainColor);
    }
  }, [location]);

  return (
    <>
      <Outlet />
    </>
  );
}
